<template>
  <div
    class="container-wrapper"
    :style="{ height: Height + 'px', width: Width + 'px' }"
  >
    <div class="container">
      <div class="left" @click="goback">
        <div class="iconfont icon-fanhui2" style="font-size:35px"></div>
      </div>
      <div class="right">
        <Button class="bkcc-btn" @click="ownerCommittee"
        >业主委员会</Button>
        <Button class="bkcc-btn" @click="downloadRecordCard"
        >下载登记卡</Button>
      </div>
      
      <div class="box wsq-header ">
        <div class="wsq-text">{{ info.zoneName }}</div>
      </div>
      <div class="head-wrapper" :style="{ height: Width * 0.06 + 'px' }">
        <img src="../../assets/images/wsq-bg-top.png" />
      </div>

      <!--</div>-->
      <div class="content-wrapper">
        <div class="people-number">
          <img
            class="people-number-icon"
            src="@/assets/images/partyDetail/peopleNumber.png"
          />
          居民:
          <span class="people-number-number">{{ info.totalNumber }}</span>
          <span class="people-unit">人</span>
        </div>
        <div class="content">
          <!-- 简介 -->
          <div class="xiangqing-wrapper">
            <div
              class="xiangqing-info"
              v-if="info.remark"
              :style="{ width: Width * 0.95 + 'px' }"
            >
              {{ info.remark }}
            </div>
            <div class="zhanwei xiangqing-info" v-else>请编辑微社区简介</div>
            <div class="xiangqing-pic-wrapper">
              <template v-for="(item, index) in imgArr">
                <img
                  v-if="item.path"
                  :key="index"
                  :src="item.path"
                  class="xiangqing-pic"
                  :style="{
                    width: Height > 750 || Width > 1550 ? '22.17%' : '20%'
                  }"
                />
              </template>
            </div>
            <Button type="warning" class="add-btn" @click="showXiangqing = true"
              >详情编辑</Button
            >
            <add-xiangqing
              :show-xiangqing="showXiangqing"
              @changsuccess="changSuccess"
              :pic-arr="imgArr"
              :shequ-info="info.remark"
              :name="info.zoneName"
              :region="info.areaRange"
              :address="info.address"
              :coordinate="info.coordinate"
              @closexiangqing="closeXiangqing"
            ></add-xiangqing>
          </div>
          <!-- 社区管理员 -->
          <admin
            :manager="manager"
            :leader="leader"
            :serviceStation="serviceStation"
            @addStation="addStation"
            @delStation="delStation"
            @addMember="addMember"
            @delMember="delMember"
            @delManager="delManager"
            @addManagerSuccess="addManagerSuccess"
          ></admin>

          <zone-property>

          </zone-property>
        </div>
      </div>
      <div>
        <img
          src="../../assets/images/wsq-bg-btm.png"
          :style="{ width: Width + 'px' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import addXiangqing from "./components/addXiangqing";
import zoneProperty from "./components/zoneProperty"
import admin from "./components/admin"; // 组件只是将业务拆分开来 并不具有通用性
var that;
export default {
  components: { admin, addXiangqing, zoneProperty },
  mounted() {
    that = this;
    window.addEventListener("resize", this.handleResize);
    this.Height = window.document.body.offsetHeight - 60;
    this.Width = window.document.body.offsetWidth;
    if (this.Height < 788) {
      this.Height = 788;
    }
    this.zoneId = this.$route.query.zoneId || sessionStorage.zoneId; // 刷新时读取
    this._saveZoneId(this.zoneId); // 比较重要 接口的zoneId就靠它了
    this._communityInfo();
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.handleResize);
  },
  destroyed() {
    console.log("[sys] partyDetail has been destroyed");
    this.$store.commit("updateNavText", "");
    this._saveZoneId(""); // 退出后 销毁zoneId
  },
  data() {
    return {
      Height: window.document.body.offsetHeight - 60,
      Width: window.document.body.offsetWidth,
      zoneId: "", // 微支部或社区id
      info: {
        remark: "",
        totalNumber: 0,
        zoneId: 0,
        zoneName: "",
        areaRange: "",
        address: "",
        coordinate: ""
      }, // 微支部或微社区的基本信息
      leader: [], // 委员
      manager: [],
      serviceStation:[],
      // manager: {
      //   id: 0,
      //   headPicUrl: "",
      //   proTitle: "",
      //   realName: "",
      //   unionId: ""
      // }, // 管理员
      showXiangqing: false, //详情编辑弹窗是否显示
      imgArr: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleResize(event) {
      this.Width = window.document.body.offsetWidth;
      this.Height = document.documentElement.clientHeight - 60;
      // this.reload();
      if (this.Height < 700) {
        this.Height = 700;
      }
      if (this.Width < 1300) {
        this.Width = 1300;
      }
    },
    // 获取页面信息
    _communityInfo() {
      that.$store.commit("updateSpinShow", true);
      let url = this.urlobj.zoneInfo(this.zoneId);
      this.$get(url)
        .then(res => {
          that.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            let _t = res.rows[0];
            // 初始化info
            this.info = {
              remark: _t.info.remark ? _t.info.remark : "",
              totalNumber: _t.info.totalNumber,
              zoneId: _t.info.zoneId,
              zoneName: _t.info.zoneName,
              areaRange: _t.info.areaRange,
              address: _t.info.address,
              coordinate: _t.info.coordinate,
            };
            // 初始化管理员
            this.manager = _t.manager.map(item => {
              return {
                headPicUrl: item.headPicUrl,
                realName: item.realName,
                unionId: item.unionId,
                phoneNO: item.phoneNO,
                id: item.id
              };
            });
            this.serviceStation = _t.serviceStation;
            console.log("serviceStation",this.serviceStation)
            // 初始化 委员
            this.leader = _t.leader.map(item => {
              return {
                id: item.id,
                headPicUrl: item.headPicUrl || "",
                proTitle: item.proTitle,
                proTitleId: item.proTitleId,
                realName: item.realName,
                unionId: item.unionId,
                phoneNO: item.officePhoneNO || item.phoneNO
              };
            });
            // 初始化图片
            this.imgArr = _t.pic.map(item => {
              return {
                id: item.picId, // 主键id
                path: item.picPath // 图片附件路径
              };
            });
            // console.log(this.imgArr);
          }
        })
        .catch(e => console.log(e));
    },
    // 进入页面时储存 zoneId
    _saveZoneId(zoneId) {
      sessionStorage.zoneId = zoneId;
    },
    // 添加负责人
    addMember(data) {
      if (data.person.change) {
        this.leader.splice(data.index, 1, data.person);
      } else {
        this.leader.push(data.person);
      }
    },
    addStation(data) {
      console.log(data);
      console.log(this.serviceStation);
      this.serviceStation[data.person.index]['userList'].push(data.person);
    },
    // 删除负责人
    delMember(index) {
      this.leader.splice(index, 1);
    },
    delStation(index) {
      console.log(index)
      this.serviceStation[index]['userList'].splice(0, 1);
    },
    // 保存详情编辑
    changSuccess(data) {
      // this.imgArr = data.img
      this.info.remark = data.remark;
      this.info.zoneName = data.name;
      this.info.areaRange = data.areaRange,
      this.info.address = data.address,
      this.info.coordinate = data.coordinate,
      this.imgArr = data.img;
      this.showXiangqing = false;
    },
    closeXiangqing() {
      this.showXiangqing = false;
    },
    addManagerSuccess(data) {
      console.log(data);
      this.manager.push(data);
    },
    delManager(index) {
      this.manager.splice(index, 1);
    },
    goback() {
      // this.$router.push({name:'miniCommunity',params:{index:that.nowIndex}})
      this.$router.go(-1);
    },
    // 下载登记卡
    downloadRecordCard() {
      let url = `${this.urlobj.walkRecordDownload}?token=${this.$store.state.access_token}&comeType=1&comeIdList=${this.zoneId}`;
      window.open(url);
    },
    ownerCommittee() {
      console.log('ownerCommittee')
       this.$router.push({
        name: "ownCommitee",
        query: { zoneId: this.zoneId, zoneName: this.info.zoneName }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container-wrapper {
  background-origin: border-box;
  padding-top: 1px;
}
.container {
  position: relative;
  overflow-y: scroll;
}
.container::-webkit-scrollbar {
  width: 0;
}
/* 头部 */
.head-wrapper {
  /*width: 100%;*/
  /*background: url("../../assets/images/wsq-bg-top.png") no-repeat;*/
  /*background-size: 100% 100%;*/
}
.content-wrapper {
  background: url("../../assets/images/wsq-bg-mid.png") no-repeat;
  background-size: 100% 100%;
}
/*.footer-wrapper{*/
/*width: 100%;*/
/*}*/
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 14px;
}
.flag {
  width: 5rem;
  height: 5rem;
  position: absolute;
  left: -110px;
  top: 15%;
}
.wsq-text {
  font-family: "KaiTi";
  /*font-size:55px;*/
  color: transparent;
  background: url("../../assets/images/wsqtext.png");
  background-repeat: repeat-x;
  -webkit-background-clip: text;
  white-space: nowrap;
  max-width: 1000px;
  overflow: hidden;
  font-weight: 600;
}
/* 成员人数  开始*/
.people-number {
  /*margin-top:6%;*/
  margin-bottom: 0.7%;
  text-align: center;
  color: #ff5642;
  font-size: 24px;
}
.people-number-icon {
  width: 32px;
  height: 26px;
  vertical-align: middle;
}
.people-number-number {
  font-size: 36px;
}
.people-unit {
  font-size: 14px;
}
/* 成员人数  结束*/
/* 内容区域 */
.content {
  width: 94%;
  margin: 0 auto;
}
.intro {
  font-size: 22px;
  line-height: 1.6em;
  color: #333;
}
.add-btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
}
.wsq-header {
  position: absolute;
  left: 50%;
  top: 2%;
  transform: translateX(-50%);
  vertical-align: top;
  background-image: url("../../assets/staticsPic/fang.png");
  background-repeat: no-repeat;
  font-size: 40px;
  padding-left: 20px;
  padding-top: 21px;
}

.xiangqing-wrapper {
  position: relative;
}
.xiangqing-pic-wrapper {
  padding-top: 3.64%;
  padding-bottom: 3.5%;
}
.xiangqing-pic {
  /*width:22.17%;*/
  margin-right: 65px;
  box-shadow: 2px 2px 4px 1px #898989;
}
.xiangqing-pic:last-child {
  margin-right: 0;
}
.xiangqing-info {
  font-size: 27px;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-all;
}
.zhanwei {
  text-align: center;
  color: #666;
}
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.right {
  position: absolute;
  right: 20px;
  top: 14px;
}
/* 支部 委员 */
</style>
